export const weekLabel: Record<string, string> = {
  Sunday: '일',
  Monday: '월',
  Tuesday: '화',
  Wednesday: '수',
  Thursday: '목',
  Friday: '금',
  Saturday: '토',
};

export const isToday = (date: Date) => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const isSameDate = (targetDate: Date, date: Date | [Date | null, Date | null]) => {
  if (Array.isArray(date)) {
    const dateString = date?.map((d) => `${d?.getFullYear()}${d?.getMonth()}${d?.getDate()}`);

    const targetDateString = `${targetDate.getFullYear()}${targetDate.getMonth()}${targetDate.getDate()}`;

    return dateString?.includes(targetDateString);
  }

  return (
    targetDate.getDate() === date.getDate() &&
    targetDate.getMonth() === date.getMonth() &&
    targetDate.getFullYear() === date.getFullYear()
  );
};

export const formatDate = (date?: Date) => {
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}.${month}.${day}`;
};

export const handleChangeFormatDate = (input: string) => {
  if (input.length >= 7) {
    const year = Number(input.slice(0, 4));
    const month = Number(input.slice(4, 6));
    const date = new Date(year, month, 0);
    const fullDay = date.getDate();
    const day = Number(input.slice(6, 8));
    const formatDay =
      day > fullDay ? fullDay : day < 10 && input.length === 8 && day !== 0 ? `0${day}` : day;
    return `${input.slice(0, 4)}.${input.slice(4, 6)}.${formatDay}`;
  } else if (input.length >= 5) {
    const month = input.slice(4, 6);
    const formatMonth = Number(month) > 12 ? '12' : month;
    return `${input.slice(0, 4)}.${formatMonth}`;
  } else if (input.length >= 1) {
    return `${input.slice(0, 4)}`;
  }

  return input;
};
